(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallz-materiaal-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function startVideo(video) {
    video.muted = true;
    video.setAttribute('playsinline', '');
    video.preload = 'auto';
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          video.setAttribute('data-wallz-inview', '1');
          startVideo(video);
        } else {
          video.removeAttribute('data-wallz-inview');
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px' });
  }

  function init() {
    document.querySelectorAll('.materiaal-video-item video').forEach(function (video) {
      video.removeAttribute('autoplay');
      if (observer) observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function resumeVisible() {
    document.querySelectorAll('.materiaal-video-item video[data-wallz-inview]').forEach(startVideo);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resumeVisible();
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) resumeVisible();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
